import { TranslationWidth } from "@angular/common";
import { Injectable } from "@angular/core";
import { NgbDatepickerI18n, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

const I18N_VALUES = {
      weekdays: ['S', 'T', 'Q', 'Q', 'S', 'S', 'D'],
      weekdayLabels: ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'],
      months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      weekLabel: 'sem'
    // other languages you would support
  };
  
  // Define custom service providing the months and weekdays translations
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
    
  constructor() { super(); }

  getWeekdayShortName(weekday: number): string { return I18N_VALUES.weekdays[weekday - 1]; }
  getWeekLabel(): string { return I18N_VALUES.weekLabel; }
  getMonthShortName(month: number): string { return I18N_VALUES.months[month - 1]; }
  getMonthFullName(month: number): string { return this.getMonthShortName(month); }
  getDayAriaLabel(date: NgbDateStruct): string { return `${date.day}/${date.month}/${date.year}`; }
  getWeekdayLabel(weekday: number, width?: TranslationWidth | undefined): string { 
    const value = I18N_VALUES.weekdayLabels[weekday - 1];
    if (!width) {
      width = TranslationWidth.Abbreviated;
    }
    switch(width) {
      case TranslationWidth.Abbreviated:
        return value.substring(0, 3);
      case TranslationWidth.Wide:
        return value;
      case TranslationWidth.Short:
        return value.substring(0, 2);
      default:
        return value.charAt(0);
    }
  }
}
  